<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-2">
<p class="copy">©2020 Neil P. Chatelain</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy2">Names: Chatelain, Neil, author.</p>
<p class="copy2">Title: Defending the arteries of rebellion : Confederate naval operations in the Mississippi River Valley, 1861-1865 / Neil Chatelain.</p>
<p class="copy2">Other titles: Confederate naval operations in the Mississippi River Valley, 1861-1865</p>
<p class="copy2">Description: El Dorado Hills, CA : Savas Beatie, LLC, [2020] | Includes bibliographical references and index. | Summary: "Defending the Arteries of Rebellion analyzes efforts by the Confederacy to maintain control of its key internal waterways across the Mississippi River Valley. It examines how numerous organizations, from the Confederate Navy, Marines, Revenue Service, Army, River Defense Fleet, state naval forces, privateers, and civilian craft, struggled to cooperate and defend the Mississippi River and its many tributary and distributary waterways, facing issues of command, supply, and overwhelming enemy forces. It also highlights how river warfare is a juggling act of constant maneuver, static fortifications, and the lingering question of where to mass forces to face the enemy"-Provided by publisher.</p>
<p class="copy2">Identifiers: LCCN 2020007691 | ISBN 9781611215106 (hardcover) | ISBN 9781611215113 (ebook)</p><p class="copy2">Subjects: LCSH: Mississippi River Valley--History--Civil War, -1865--Campaigns. | Mississippi River Valley--History--Civil War, 1861-1865--Riverine operations. | Confederate States of America.Navy--History. | United States--History--Civil War, 1861-1865--Campaigns. | United States--History--Civil War, 1861-1865--Naval operations.</p>
<p class="copy2">Classification: LCC E470.8 .C64 2020 | DDC 973.7/57--dc23</p>
</a><p class="copy2"><a id="VPS-2">LC record available at <span class="weblink"></span></a><a href="http://lccn.loc.gov/2020007691" target="_blank"><span class="underline">https://lccn.loc.gov/2020007691</span></a></p>
<p class="copy1">First Edition, First Printing</p>
<div class="img_container1">
<img alt="image" src="images/logo_1.jpg"/>
</div>
<p class="copy2">Savas Beatie</p>
<p class="copy2">989 Governor Drive, Suite 102</p>
<p class="copy2"> El Dorado Hills, CA 95762</p>
<p class="copy2">916-941-6896 / <span class="weblink"><a href="mailto://sales@savasbeatie.com" target="_blank"><span class="underline">sales@savasbeatie.com</span></a></span> / <span class="weblink"><a href="http://www.savasbeatie.com" target="_blank"><span class="underline">www.savasbeatie.com</span></a></span></p>
<p class="copy1">All of our titles are available at special discount rates for bulk purchases in the United States. Contact us for information.</p>
<p class="copy">Proudly published, printed, and warehoused in the United States of America.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Copyright.vue?32a97273